import { SetPasswordForm, tokenFromSearch } from './SetPasswordForm';

export { PasswordInput } from './SetPasswordForm';

/**
 * Public set-password page an invite email links to (HUB-106):
 * `/login/invite?token=…`. The form itself is shared with the self-service
 * reset page (`SetPasswordForm`); only the copy differs.
 */
export const inviteTokenFromSearch = tokenFromSearch;

const EXPIRED_MESSAGE = 'This link is no longer valid. Ask your administrator to send a new invite.';

export function Invite({ token }: { token: string | null }) {
  return (
    <SetPasswordForm
      token={token}
      title="Set your password"
      submitLabel="Set password and sign in"
      expiredMessage={EXPIRED_MESSAGE}
    />
  );
}

/** Route element: reads the token from the current URL. */
export function InvitePage() {
  return <Invite token={inviteTokenFromSearch(typeof window === 'undefined' ? '' : window.location.search)} />;
}
